import { EventDetailsFilter, EventDetailsParams } from './types';

export const eventDetailsFilterOptions: { label: string; value: EventDetailsFilter }[] = [
  {
    label: 'All',
    value: EventDetailsFilter.ALL,
  },
  {
    label: 'Failures',
    value: EventDetailsFilter.FAILURES,
  },
];

export const defaultEventDetailParams: EventDetailsParams = {
  failuresOnly: false,
  pageSize: 25,
  pageNumber: 1,
};

export const EVENT_TYPES = ['page', 'screen', 'track', 'identify', 'group', 'alias', 'other'];

// Non-standard 2xx status code marking deliveries the destination accepted but
// flagged with a non-fatal warning (alongside the 298 filter / 299 suppress convention)
export const DELIVERED_WITH_WARNING_STATUS_CODE = 296;

export const EVENT_NAME_DATA_AVAILABLE_FROM_DATE = '2025-02-25';
